const normalizeBase = value => {
  if (!value || typeof value !== 'string') {
    return null;
  }

  return value.replace(/\/+$/, '');
};

const normalizeApiBase = value => {
  const normalized = normalizeBase(value);
  if (!normalized) {
    return null;
  }

  return /\/api$/i.test(normalized) ? normalized : `${normalized}/api`;
};

export const stripApiSuffix = value => {
  const normalized = normalizeBase(value);
  if (!normalized) {
    return null;
  }

  return normalized.replace(/\/api$/i, '');
};

const isLocalDevHost = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const { hostname } = window.location;
  return ['localhost', '127.0.0.1', '::1', '[::1]'].includes(hostname);
};

const collectCandidates = () => {
  const envBase = normalizeApiBase(process.env.REACT_APP_PHP_BACKEND_URL);
  const currentOriginBase =
    !isLocalDevHost() && typeof window !== 'undefined' ? normalizeApiBase(window.location.origin) : null;
  const directPsiBase = 'https://psixologiya.suvoriy.com/api';
  const candidates = [];

  if (envBase) {
    candidates.push(envBase);
  }

  if (currentOriginBase) {
    candidates.push(currentOriginBase);
  }

  if (isLocalDevHost()) {
    candidates.push('/api');
  }

  candidates.push(directPsiBase);

  return candidates.filter((item, index, arr) => item && arr.indexOf(item) === index);
};

const collectSiteCandidates = () => {
  const envBase = stripApiSuffix(process.env.REACT_APP_PHP_BACKEND_URL);
  const candidates = [];

  if (!isLocalDevHost() && typeof window !== 'undefined') {
    candidates.push(normalizeBase(window.location.origin));
  }

  if (envBase) {
    candidates.push(envBase);
  }

  candidates.push('https://psixologiya.suvoriy.com/');

  return candidates.filter((item, index, arr) => item && arr.indexOf(item) === index);
};

export const API_PROXY_TARGET = (() => {
  const envBase = normalizeApiBase(process.env.REACT_APP_PHP_BACKEND_URL);
  if (!envBase) {
    return 'https://psixologiya.suvoriy.com/api';
  }

  return envBase;
})();

export const API_BASE_CANDIDATES = collectCandidates();
export const SITE_BASE_CANDIDATES = collectSiteCandidates();
const API_BASE_URL = API_BASE_CANDIDATES[0] || 'https://psixologiya.suvoriy.com/api';

export default API_BASE_URL;
